// ============================================
// Detail Module - Like (ES6)
// 좋아요 기능
// ============================================

import {
  getIsLikeProcessing,
  setIsLikeProcessing,
  getSelectedContent,
  getDb,
  getPublishedCache
} from './state.js';
import { HOME_ENDPOINTS } from '../../shared/api-endpoints.js';
import { authFetch } from '../../shared/auth-fetch.js';
import { getCurrentUser } from '../../app/state.js';
import { showLoginModal } from '../../auth/index.js';
import { showToast } from '../../utils.js';

// ============================================
// 좋아요 버튼 상태 업데이트
// ============================================

export async function updateLikeButtonState(contentId) {
  const likeBtn = document.getElementById('detailLikeBtn');
  const user = getCurrentUser();

  // 비로그인 시 좋아요 상태 초기화
  if (!user) {
    likeBtn.classList.remove('liked');
    return;
  }

  const db = getDb();

  try {
    // Firestore 직접 쿼리 - 좋아요 상태 확인
    const likeDoc = await db.collection('published').doc(contentId)
      .collection('likes').doc(user.uid).get();

    if (likeDoc.exists) {
      likeBtn.classList.add('liked');
    } else {
      likeBtn.classList.remove('liked');
    }
  } catch (e) {
    console.error('Failed to check like status:', e);
  }
}

// ============================================
// 좋아요 토글
// ============================================

export async function toggleContentLike() {
  const user = getCurrentUser();
  if (!user) {
    showLoginModal();
    return;
  }

  const selectedContent = getSelectedContent();
  if (!selectedContent) {
    return;
  }

  // 중복 클릭 방지
  if (getIsLikeProcessing()) return;
  setIsLikeProcessing(true);

  const contentId = selectedContent.id;
  const likeBtn = document.getElementById('detailLikeBtn');
  const countEl = document.getElementById('detailLikeCount');

  // 버튼 비활성화 표시
  likeBtn.style.opacity = '0.5';
  likeBtn.style.pointerEvents = 'none';

  try {
    const response = await authFetch(HOME_ENDPOINTS.toggleLike, {
      body: { contentId }
    });

    if (!response.ok) throw new Error('서버 오류');

    const result = await response.json();
    const cache = getPublishedCache();
    // 캐시에서 해당 콘텐츠 찾기 (character 또는 story)
    let cached = cache.character.find(c => c.id === contentId)
      || cache.story.find(c => c.id === contentId);

    if (result.liked) {
      likeBtn.classList.add('liked');
      countEl.textContent = parseInt(countEl.textContent) + 1;
      if (cached) cached.likeCount = (cached.likeCount || 0) + 1;
    } else {
      likeBtn.classList.remove('liked');
      countEl.textContent = Math.max(0, parseInt(countEl.textContent) - 1);
      if (cached) cached.likeCount = Math.max(0, (cached.likeCount || 0) - 1);
    }
  } catch (e) {
    showToast('좋아요 처리 실패', 'error');
    console.error(e);
  } finally {
    // 버튼 활성화 복원
    likeBtn.style.opacity = '1';
    likeBtn.style.pointerEvents = 'auto';
    setIsLikeProcessing(false);
  }
}
